import {
  AbsoluteContainer,
  AppText,
  Button,
  CustomContainer,
  FlexColumn,
  FlexRow,
  Form,
  FormGroup,
  FormGroupWithIcon,
  SidePopupContainer,
} from "src/style";
import { RiCloseFill } from "react-icons/ri";
// ...existing code...
import AppInfoContext from "src/provider/state-manager/appInfoProvider";
import { useContext, useEffect, useState } from "react";
import ApiContext from "src/provider/API/call-service";
import { useTranslation } from "react-i18next";
import { surevyNames } from "src/model";

type SurveyTrigger = {
  id?: string;
  triggerName: string;
  triggerDescription: string;
  surveyInterval: number;
};

export const NewSurveyTrigger = ({
  close,
  ibInstitutionCode,
  refetchTriggers,
  isEdit,
  initialSurveyTriggerDetails,
}: {
  close: () => void;
  ibInstitutionCode: number;
  refetchTriggers: () => void;
  isEdit: boolean;
  initialSurveyTriggerDetails?: Record<string, any>;
}) => {
  const { API } = useContext(ApiContext);
  const { t } = useTranslation();

  const [input, setInput] = useState<SurveyTrigger>({
    id: initialSurveyTriggerDetails ? initialSurveyTriggerDetails?.id : "",
    triggerName: initialSurveyTriggerDetails
      ? initialSurveyTriggerDetails?.triggerName
      : "",
    triggerDescription: initialSurveyTriggerDetails
      ? initialSurveyTriggerDetails?.triggerDescription
      : "",
    surveyInterval: initialSurveyTriggerDetails
      ? initialSurveyTriggerDetails?.surveyInterval
      : 0,
  });

  const handleInput = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;

    if (name === "triggerName" && value.length > 100) return;
    if (name === "triggerDescription" && value.length > 1000) return;
    if (name === "surveyInterval") {
      if (value === "") {
        setInput({ ...input, surveyInterval: "" as any });
        return;
      }

      const num = Number(value);
      if (Number.isNaN(num)) return;

      setInput({ ...input, surveyInterval: num });
      return;
    }

    setInput({ ...input, [name]: value });
  };

  const handleSubmit = async (
    e: React.FormEvent<HTMLFormElement> | React.FormEvent<HTMLButtonElement>
  ) => {
    e.preventDefault();
    const payload = {
      ibInstitutionCode: ibInstitutionCode,
      ...(isEdit ? { id: input.id } : {}),
      surveyInterval: input?.surveyInterval,
      triggerName: input.triggerName,
      triggerDescription: input.triggerDescription,
    };

    const response = await API.saveSurveyTrigger(payload);
    if (response) {
      close();
      refetchTriggers();
    }
  };

  return (
    <>
      <SidePopupContainer>
        <FlexColumn
          className="new-ads-container"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <AbsoluteContainer top="1.5" right="1.5">
            <Button
              titleSize="2"
              fontWeight="500"
              width="3.4"
              shadow="none"
              height="3.4"
              radius="0.4"
              bgColor="#ffffff"
              hoverBgColor="#FEF3F2"
              borderColor="none"
              color="#000000"
              hoverColor="#B42318"
              onClick={close}
            >
              <RiCloseFill style={{ fontSize: "2.3rem" }} />
            </Button>
          </AbsoluteContainer>
          <AppText
            color="#101828"
            textSize="1.8"
            fontWeight="700"
            fontFamily="Gilmer-Bold"
          >
            {isEdit
              ? t("newSurveyTrigger.editSurvey")
              : t("newSurveyTrigger.addNewSurvey")}
          </AppText>
          <Form onSubmit={handleSubmit}>
            <FormGroup topMargin="2">
              <label>{t("newSurveyTrigger.surveyName")}</label>
              <select
                name="triggerName"
                value={input.triggerName || ""}
                onChange={handleInput}
                autoComplete="off"
              >
                <option value="">
                  {t("newSurveyTrigger.selectSurveyName")}
                </option>
                {surevyNames.map((option: any, index: number) => (
                  <option key={index} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </FormGroup>

            <FormGroup topMargin="2">
              <label>{t("newSurveyTrigger.triggerDescription")}</label>
              <input
                placeholder={t("newSurveyTrigger.enterTriggerDescription")}
                name="triggerDescription"
                value={input.triggerDescription ?? ""}
                onChange={handleInput}
                required
              />
            </FormGroup>

            <FormGroup topMargin="2">
              <label>{t("newSurveyTrigger.intervalDays")}</label>
              <input
                type="number"
                min={1}
                name="surveyInterval"
                value={input.surveyInterval}
                onChange={handleInput}
                required
              />
            </FormGroup>

            <FlexRow justifyContent="flex-end" topMargin="2" gap="2">
              <Button
                type="button"
                onClick={close}
                width="12"
                titleSize="1.4"
                fontWeight="600"
                height="4"
                radius="0.8"
                bottomMargin="1"
                bgColor="#fff"
                color="#000"
                hoverColor="#0D968F"
                hoverBgColor="#fff"
                borderColor="#000"
              >
                {t("newSurveyTrigger.cancel")}
              </Button>
              <Button
                type="submit"
                width="12"
                titleSize="1.4"
                fontWeight="600"
                height="4"
                radius="0.8"
                bottomMargin="1"
                hoverColor="#0D968F"
                hoverBgColor="#fff"
                borderColor="#0D968F"
              >
                {isEdit
                  ? t("newSurveyTrigger.updateSurvey")
                  : t("newSurveyTrigger.createSurvey")}
              </Button>
            </FlexRow>
          </Form>
        </FlexColumn>
      </SidePopupContainer>
    </>
  );
};
